import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Composant utilitaire qui remonte en haut de la page lors d'un changement de route.
 * Particulièrement utile sur mobile où le scroll peut persister entre les pages.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Ne pas remonter si on est dans le workspace (gestion spécifique du scroll interne)
    if (pathname.includes("/workspace/")) {
      return;
    }

    // 1. Remonter la fenêtre principale (pour layout classique)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

    // 2. Remonter le conteneur principal de l'app (pour layout "SPA")
    const mainContainer = document.querySelector("[data-app-main]");
    if (mainContainer) {
      mainContainer.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }

    // Doublon de sécurité pour mobile avec un léger délai
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
      if (mainContainer) {
        mainContainer.scrollTo(0, 0);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}
